// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetMassChannelPdiClaim,
    updateGoodsInstallationVatDropDown,
    updateMassChannelPdiClaimInputOnBlur,
    updateMassChannelPdiClaimProperty,
    updateMassChannelPdiClaimReferenceInfoProperty,
    updateMassChannelPdiPin,
    updateResponsibleAccountsDropDown,
    updateRetailerNameDropDown,
    updateStickyHeaderVisibility
} from './claim-details';
import {copyAttachments} from '../../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createMassChannelPdiClaim} from './validate-claim';
import {onEditClaim} from '../../../shared/action-creators/edit-claim';
import {readClaimTypes} from './get-claim-types';
import {readGoodsInstallationVatOptions} from '../../../shared/action-creators/get-goods-installation-vat-options';
import {readMassChannelPdiClaim} from './get-mass-channel-pdi-claim';
import {readOtherCreditDescriptions} from '../../../shared/action-creators/other-credit-descriptions';
import {readRetailerNames} from './get-retailer-names';
import {updateIsEditable} from './is-editable';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';

export default {
    addFile,
    copyAttachments,
    copyClaim,
    createMassChannelPdiClaim,
    deleteFile,
    onCreateClaim,
    onEditClaim,
    readClaimTypes,
    readGoodsInstallationVatOptions,
    readMassChannelPdiClaim,
    readOtherCreditDescriptions,
    readRetailerNames,
    resetConfirmationModal,
    resetMassChannelPdiClaim,
    setConfirmationModal,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateGoodsInstallationVatDropDown,
    updateIsEditable,
    updateMassChannelPdiClaimInputOnBlur,
    updateMassChannelPdiClaimProperty,
    updateMassChannelPdiClaimReferenceInfoProperty,
    updateMassChannelPdiPin,
    updateResponsibleAccountsDropDown,
    updateRetailerNameDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey
};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/index.js